module.exports = {"321002001":"东关街道","321002002":"汶河街道","321002003":"文峰街道","321002004":"曲江街道","321002102":"李典镇","321002103":"沙头镇","321002104":"头桥镇","321002106":"湾头镇","321002200":"汤汪乡","321002400":"产业园","321002401":"扬州市生态科技新城杭集镇","321002402":"扬州市生态科技新城泰安镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/321002.json
// module id = 914
// module chunks = 0